import styled from "styled-components";

export const Container = styled.div`
    width: 500px; 
    height: 40vh; 
`

export const PickerWrapper = styled.div`
    margin-bottom: 26px; 
`

export const ItemsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
`